<template>
    <div class="container" v-if="backendError">
        <p class="error">Error {{backendError}} in communication with the backend.</p>
        <div style="margin-top: 1rem;">
            <b-button type="is-primary" @click="handleRetry">Retry</b-button>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {BButton},
    name: "backend-error",
    computed: {
      ...mapGetters('ui', ['backendError'])
    },
    methods: {
      handleRetry() {
        location.reload(true);
      }
    }
  }
</script>

<style scoped>
    .error {
        color: #FF0000;
        font-weight: bold;
    }
</style>